{
	"label": "Virhe",
	"title": "Jokin meni pieleen",
	"body": "Sivua ei voitu ladata. Yritä uudelleen tai palaa etusivulle.",
	"tryAgain": "Yritä uudelleen",
	"goHome": "Etusivulle",
	"listingNotFound": {
		"code": "404",
		"title": "Ilmoitusta ei löydy",
		"description": "Tämä ilmoitus on ehkä poistettu tai linkki on virheellinen.",
		"browse": "Selaa ilmoituksia"
	}
}
